import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Steps } from "antd";
import { noop } from "lodash";
import HomeHealthCompanyForm from "../components/HomeHealthCompanyForm";
import HomeHealthAddressForm from "../../../../common/AtmedVendorAddressForm";

const { Step } = Steps;

const HomeHealthCareFormModal = ({
  data = {},
  visible,
  onSubmit,
  allCountry,
  countryCode,
  onCancel,
  title,
  submitText,
  footer,
  ...props
}) => {
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);
  const [currentValue, setCurrentValue] = useState(data);
  const [picUrl, setPicUrl] = useState(data && data.pic_url);

  const onModalCancel = async () => {
    await form.resetFields();

    await setCurrentValue();
    setPicUrl("");
    onCancel();
    setCurrentStep(0);
  };

  const onOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        currentValue.established_year = new Date(currentValue.established_year)
          .getFullYear()
          .toString();
        await onSubmit({ ...currentValue, ...values });
        form.resetFields();
        setCurrentValue();
        onModalCancel();
        await setCurrentStep(0);
      })
      .catch(noop);
  };
  const onNextStep = () => {
    form
      .validateFields()
      .then(async (values) => {
        values.tax_no = values.tax === false ? null : values.tax_no;
        setCurrentStep(currentStep + 1);
        setCurrentValue({ ...currentValue, ...values, pic_url: picUrl });
      })
      .catch(noop);
  };
  const onPrevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  useEffect(() => {
    setPicUrl(data && data.pic_url);
    form.resetFields();
    setCurrentValue();
  }, [visible]);

  const steps = [
    {
      title: "Company Details",
      content: (
        <HomeHealthCompanyForm
          currentValue={currentValue}
          form={form}
          picUrl={picUrl}
          countryCode={countryCode}
          allCountry={allCountry}
          initialValues={currentValue === undefined ? data : currentValue}
          setPicUrl={(d) => setPicUrl(d)}
        />
      ),
    },
    {
      title: "Address & Banking Details",
      content: (
        <HomeHealthAddressForm
          form={form}
          initialValues={data === null ? currentValue : data}
        />
      ),
    },
  ];
  const modalFooter = (
    <>
      {footer}
      {currentStep > 0 && <Button onClick={onPrevStep}>Prev</Button>}
      {currentStep < 1 && (
        <Button type="primary" onClick={onNextStep}>
          Next
        </Button>
      )}
      {currentStep === 1 && (
        <Button type="primary" onClick={onOk}>
          {submitText}
        </Button>
      )}
    </>
  );

  return (
    <Modal
      visible={visible}
      onCancel={onModalCancel}
      onOk={onOk}
      title={title}
      okText={submitText}
      destroyOnClose
      footer={modalFooter}
      width={1000}
      maskClosable={false}
      {...props}
    >
      <Steps current={currentStep} size="small" style={{ marginBottom: 10 }}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <div className="steps-content">{steps[currentStep].content}</div>
    </Modal>
  );
};
export default HomeHealthCareFormModal;
